import { render, staticRenderFns } from "./OdontogramHistoryEntry.vue?vue&type=template&id=fcf81a1e"
import script from "./OdontogramHistoryEntry.vue?vue&type=script&lang=js"
export * from "./OdontogramHistoryEntry.vue?vue&type=script&lang=js"
import style0 from "./OdontogramHistoryEntry.vue?vue&type=style&index=0&id=fcf81a1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports